import Field from "../field"
import { SegmentedControl } from "./native"

export default function Segment({ items, ...props }){
    return(
    <Field {...props}>
        <SegmentedControl
            items={items}
            {...props}
        />
    </Field>
    )
}